export interface AnimationData {
	dataLight: string;
	dataDark?: string;
	aspectRatio?: string;
}

export const fetchAnimationData = async (src: string): Promise<AnimationData | null> => {
	try {
		const response = await fetch(src);
		if (!response.ok) {
			throw new Error(`Error fetching animation data: ${response.status}`);
		}
		return await response.json();
	} catch (error) {
		console.error('Error fetching animation data', error);
		return null;
	}
};

export const getCurrentAnimationData = (
	data: Pick<AnimationData, 'dataLight' | 'dataDark'>,
	colorScheme = document.documentElement.getAttribute('data-color-scheme'),
): string => {
	const isDark = colorScheme === 'dark';
	return isDark && data.dataDark ? data.dataDark : data.dataLight;
};
